module.exports = __webpack_public_path__ + "static/media/inventoryAptAutobook.5e3cc300.svg";